import { render, staticRenderFns } from "./CalendarEvents.vue?vue&type=template&id=7fe8c6b2&"
import script from "./CalendarEvents.vue?vue&type=script&lang=js&"
export * from "./CalendarEvents.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEvents.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe8c6b2')) {
      api.createRecord('7fe8c6b2', component.options)
    } else {
      api.reload('7fe8c6b2', component.options)
    }
    module.hot.accept("./CalendarEvents.vue?vue&type=template&id=7fe8c6b2&", function () {
      api.rerender('7fe8c6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CalendarEvents.vue"
export default component.exports